// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3hv9O","left":"InfoRow_left__1dCNa"};